<template lang="pug">
  div(v-cloak)
    v-layout(row wrap)
      v-flex(xs12)
        v-toolbar(flat dense).secondary
          v-icon.white--text fa-users
          v-toolbar-title.white--text {{$t('customer.title')}}

    v-layout(row wrap)
      v-flex(xs12 md6)

        v-text-field.ma-0.mb-1(
          :placeholder="$t('search_by_keyword') + ' (' + keywordHint + ')'"
          type="text"
          v-model="keyword"
          autocapitalize="off"
          prepend-icon="search"
          autofocus
          clearable
          hide-details
        )

      v-flex(xs12)
        v-card
          v-card-text.pa-0
            ul.app-list-slim
              li.list-header
                ul
                  li.w40px.align-right #
                  li.w20per.hidden-md-and-up 会社コード
                  li.w10per.hidden-sm-and-down 会社コード
                  li 会社名称
                  li.w60per.hidden-sm-and-down 担当者
                  li.w20px.align-right
                    app-append(v-on:complete="onAppendSaved")
              li
                ul(
                  v-for="company, coIndex in filteredList"
                  :key="company.id"
                )
                  li.w40px.align-right {{coIndex + 1}}
                  li.w20per.hidden-md-and-up {{company.code}}
                  li.w10per.hidden-sm-and-down {{company.code}}
                  li {{company.name}}
                  li.w60per.hidden-sm-and-down
                    v-chip(
                      color="success"
                      v-for="customer in company.customers"
                      :key="customer.id"
                      outline
                      small
                      disabled
                    )
                      v-avatar
                        v-icon fa-user
                      | {{customer.name}}
                  li.w20px.text-xs-right
                    app-edit(
                      :company="company"
                      v-on:complete="onEditSaved"
                    )
</template>

<script>
import AppAppend from './Append'
import AppEdit from './Edit'
import _ from 'underscore'

export default {
  data () {
    return {
      keyword: null,
      keywordHint: ['会社コード', '会社名称', '担当者'].join('/'),
      list: []
    }
  },
  components: {
    AppAppend,
    AppEdit
  },
  created () {
    let self = this
    self.$ajax.get('companies').then(function (response) {
      self.list = _.map(response.data.list, function (row) {
        return Object.assign(row, {
          tags: [row.code, row.name].concat(_.pluck(row.customers, 'name'))
        })
      })
    })
  },
  beforeDestory () {
    this.list = []
  },
  computed: {
    filteredList () {
      let self = this
      if (self.keyword === '' || self.keyword === null) {
        return self.list
      }
      let search = new RegExp(self.keyword)
      return _.filter(self.list, function (row) {
        let searchText = row.tags === null ? '' : row.tags.join(' ')
        return search.test(searchText)
      })
    }
  },
  methods: {
    onAppendSaved (one) {
      this.list.push(
        Object.assign(one, {
          tags: [one.code, one.name].concat(_.pluck(one.customers, 'name'))
        })
      )
    },
    onEditSaved (id, one) {
      let index = _.findIndex(this.list, function (row) {
        return row.id === id
      })
      this.list.splice(
        index,
        1,
        Object.assign(one, {
          tags: [one.code, one.name].concat(_.pluck(one.customers, 'name'))
        })
      )
    }
  }
}
</script>

<style scoped lang="stylus">
</style>



// WEBPACK FOOTER //
// src/app/pages/Customer/index.vue